import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Overlay from '../../_atomic/Overlay/Overlay';
import './Modal.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
  requestClose: PropTypes.func,
};
const defaultProps = {
  visible: false,
  className: '',
  requestClose: () => {},
};

const Modal = ({
  children, visible, className, requestClose,
}) => {
  const modalClassNames = classNames({
    'modal-wrapper': true,
    'show-modal': visible,
    [className]: true,
  });
  const onKeyDownHandler = () => {
    requestClose();
  };
  const onClickHandler = () => {
    requestClose();
  };
  return (
    <Overlay onKeyDown={onKeyDownHandler} visible={visible} onClick={onClickHandler} >
      <div className={modalClassNames} >
        <div className="modal-content">
          {children}
        </div>
      </div>
    </Overlay>
  );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;



// WEBPACK FOOTER //
// ./src/components/_molecules/Modal/Modal.js